<script lang='ts'>
    export let fill: string = '#7DDEFB';
</script>

<div class="svg-box">
    <svg
      {fill}
      height="100%"
      width="100%"
      class="vector svg-content"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 7V14H13V7H11ZM11 15V17H13V15H11ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12Z" fill={fill}/>
     
    </svg>
</div>